<template>
  <div>
    <back-btn />
    <v-container>
      <v-row no-gutters justify="center">
        <v-col cols="10">
          <patient-form @emitData="createPatient" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PatientForm from "@/components/patient/PatientForm";
import BackBtn from "../../components/navigation/BackBtn.vue";

export default {
  components: {
    PatientForm,
    BackBtn,
  },
  data: () => ({
    cumps: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Patient",
        disabled: false,
        href: "/patient",
      },
      {
        text: "Patient Form",
        disabled: true,
      },
    ],
  }),
  methods: {
    createPatient(payload) {
      console.log(payload);
      this.$store.dispatch("Patient/createPatient", payload).then(() => {
        this.$router.push("/patient");
      });
    },
  },
};
</script>
